<div class="px-8">
  <p-card class="m-2">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
      <div class="flex justify-between items-center border-b pb-4">
        <h2 class="text-xl font-bold text-gray-800">{{ isEditMode ? 'Editar Conta Bancária' : 'Nova Conta Bancária' }}</h2>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Nome da Conta *</label>
          <input pInputText type="text" formControlName="accountName" class="w-full" [ngClass]="{'ng-invalid ng-dirty': form.get('accountName')?.invalid && form.get('accountName')?.touched}" />
          <small class="text-red-500" *ngIf="form.get('accountName')?.invalid && form.get('accountName')?.touched">Nome é obrigatório</small>
        </div>
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Saldo Inicial *</label>
          <p-inputNumber formControlName="initialBalance" mode="currency" currency="BRL" locale="pt-BR" class="w-full" [ngClass]="{'ng-invalid ng-dirty': form.get('initialBalance')?.invalid && form.get('initialBalance')?.touched}"></p-inputNumber>
          <small class="text-red-500" *ngIf="form.get('initialBalance')?.invalid && form.get('initialBalance')?.touched">Saldo inicial é obrigatório</small>
        </div>
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Data do Saldo *</label>
          <p-calendar formControlName="balanceDate" dateFormat="dd/mm/yy" showIcon="true" class="w-full" [ngClass]="{'ng-invalid ng-dirty': form.get('balanceDate')?.invalid && form.get('balanceDate')?.touched}"></p-calendar>
          <small class="text-red-500" *ngIf="form.get('balanceDate')?.invalid && form.get('balanceDate')?.touched">Data do saldo é obrigatória</small>
        </div>
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Status</label>
          <p-dropdown [options]="[{label: 'Ativo', value: true}, {label: 'Inativo', value: false}]" formControlName="active" placeholder="Selecione o status" class="w-full"></p-dropdown>
        </div>
      </div>
      <div class="pt-4 text-right">
        <button pButton type="button" label="Cancelar" icon="pi pi-times" class="p-button-secondary mr-2" (click)="goBack()"></button>
        <button pButton type="submit" label="Salvar" icon="pi pi-save" class="p-button-primary"></button>
      </div>
    </form>
  </p-card>
</div> 